<span [ngClass]="classMap">
  <input #inputElement type="radio" class="ant-radio-input" [disabled]="dwDisabled" [(ngModel)]="dwChecked" (blur)="onBlur()" [attr.name]="name">
  <span class="ant-radio-inner"></span>
</span>
<span><ng-content></ng-content></span>